<kendo-splitter class="padding">

    <kendo-splitter-pane class="style-splitter" size="50%">
        <!-- <kendo-label class="label" text="Companies"></kendo-label> -->
        <!-- <div class="search-box" style="height: 8%; margin-bottom: 15px;">

            <kendo-textbox [(value)]="searchTerm" [style.width.px]="338" [clearButton]="true"
                placeholder="Search on Project Name, Project Number"
                (valueChange)="onFilter($event)"></kendo-textbox>&nbsp;&nbsp;

        </div> -->
        <div style="height:100%;">
            <kendo-grid class="k-grid k-grid-header custom2" style="height:100%;" [kendoGridBinding]="displayProjects"
                kendoGridSelectBy="projectId" [(selectedKeys)]="selection" [selectable]="{ mode: 'single'}"
                [loading]="loading" [sortable]="true" [size]="smallSize" [resizable]="true"
                (cellClick)="onCellClick($event)" scrollable="virtual" [pageSize]="pageSize" [rowHeight]="15"
                [filterable]="false">
                <ng-template kendoGridToolbarTemplate>
                        <input type="text" class="kendo-like-input" placeholder="Search on Project Name or Number"
                        [(ngModel)]="searchTerm" [ngModelOptions]="{ standalone: true }" (ngModelChange)="onFilter($event)" kendoGridToolbarFocusable />
                    <kendo-grid-spacer></kendo-grid-spacer>

                    <button kendoGridExcelCommand class="allbuttons" [svgIcon]="excelSVG">
                        Export
                    </button>
                </ng-template>
                <kendo-grid-column field="projectId" title="ID" [width]="40"></kendo-grid-column>
                <kendo-grid-column field="projectname" title="Project Name" [width]="200"></kendo-grid-column>
                <kendo-grid-column field="projectnumber" title="Project Number" [width]="100"></kendo-grid-column>

                <kendo-grid-column field="location" title="Location" [width]="100">
                    <ng-template kendoGridEditTemplate>
                        <kendo-dropdownlist
                            [data]="locations"
                            [valuePrimitive]="true">
                        </kendo-dropdownlist>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="idocs_project_id" title="iDocs Project Id" [width]="120">
                </kendo-grid-column>
                <kendo-grid-excel [fileName]="getFileName()"></kendo-grid-excel>
            </kendo-grid>
        </div>
    </kendo-splitter-pane>
    <kendo-splitter-pane>

        <!-- <form class="k-form k-form-md" [formGroup]="companyform"> -->
        <form class="k-form k-form-md" [formGroup]="form">
            <div style="width:400px;">
                <button class="adminbutton allbuttons" kendoButton (click)="onAddButtonClick()"
                    [disabled]="addbuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[0]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Add</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onRemoveButtonClick()" [disabled]="removebuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[1]" style="margin-right: 1px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Remove</div>
                    </div>
                </button>
                <button class="adminbutton allbuttons" style="margin-left: 10px;" kendoButton
                    (click)="onSaveButtonClick()" [disabled]="savebuttonstate" [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[2]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Save</div>
                    </div>
                </button>
                <!-- style="right: 0; margin-left: 100px;" -->
                <!-- <button class="button-wrap" kendoButton (click)="onUploadClick()" [disabled]="uploadbuttonstate"
                    [hidden]="buttonshidden">
                    <div style="display: flex;">
                        <kendo-svg-icon [icon]="iconNames[3]" style="margin-right: 2px;margin-top: 2px"
                            size="medium"></kendo-svg-icon>
                        <div>Upload</div>
                    </div>
                </button> -->
            </div>

            <div class="wrap1">
                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #projectid id="projectid" [for]="projectid" text="ID"></kendo-label>
                        <kendo-textbox [style.width.px]="90" class="readonly" formControlName="projectid"
                            [readonly]="true"></kendo-textbox>
                    </kendo-formfield>
                    <kendo-formfield>
                        <kendo-checkbox style="margin-left:20px;" #active formControlName="active"
                            (change)="projectEnabledChange($event)"></kendo-checkbox>
                        <kendo-label class="label" [for]="active" text="Enabled"></kendo-label>



                    </kendo-formfield>
                </div>
                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" #projectname id="projectname" [for]="projectname"
                            text="Project Name"></kendo-label>
                        <kendo-textbox [style.width.px]="400" #projectnametext class="class-id"
                            formControlName="projectname" [readonly]="readonly"
                            (valueChange)="valueChange($event)"></kendo-textbox>
                    </kendo-formfield>
                </div>
                <kendo-formfield>
                    <kendo-label class="label" #projectnumber id="projectnumber" [for]="projectnumber"
                        text="Project Number"></kendo-label>
                    <kendo-textbox [style.width.px]="300" class="class-id" formControlName="projectnumber"
                        [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                </kendo-formfield>

                <div class="wrap">
                    <kendo-formfield>
                        <kendo-label class="label" [for]="location" text="Location"></kendo-label>
                        <kendo-dropdownlist #location [data]="locations"
                            [valuePrimitive]="true"
                            formControlName="location" (valueChange)="locationChange($event)"
                            [style.width.px]="180">
                        </kendo-dropdownlist>
                    </kendo-formfield>
                </div>

                <kendo-formfield>
                    <kendo-label class="label" #idocsprojectid id="idocs_project_id" [for]="idocs_project_id"
                        text="iDocs Project ID"></kendo-label>
                    <kendo-textbox #idocs_project_id [style.width.px]="300" class="class-id" formControlName="idocs_project_id"
                        [readonly]="readonly" (valueChange)="idValueChange($event)"></kendo-textbox>
                </kendo-formfield>


                <!-- <kendo-formfield>
                    <kendo-label class="label" #idocs_project_number id="idocs_project_number"
                        [for]="idocs_project_number" text="iDocs Project Number"></kendo-label>
                    <kendo-textbox [style.width.px]="300" class="class-id" formControlName="idocs_project_number"
                        [readonly]="readonly" (valueChange)="valueChange($event)"></kendo-textbox>
                </kendo-formfield> -->





            </div>




        </form>
    </kendo-splitter-pane>
</kendo-splitter>

<kendo-dialog *ngIf="showErrorDialog" (close)="showErrorDialog = false">
    <kendo-dialog-titlebar>
        Error
    </kendo-dialog-titlebar>
    <p>{{ errorMessage }}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="showErrorDialog = false">OK</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!-- <div>
    <kendo-window title={{windowTitle}} *ngIf="openedexcelwindow" (close)="closeExcelWindow()"  [width]="700"
        [height]="550" [resizable]="false" [top]="20" [left]="30">
        <br>
       
          <div id="spreadsheet" >
            <kendo-spreadsheet 
            [sheets]="exceldata" 
            #spreadsheet
            style="height: 400px; width: 100%"
            [rowHeight]="20"
            [headerHeight]="10"
            [columns]="3"
            [rows]="3"
            [menuItems]="items"
            (excelExport)="onExcelExport($event)"
    
            >

            </kendo-spreadsheet>

        </div>
    

  
        
            <div class="k-actions k-actions-end">
                <button kendoButton type="button" (click)="closeExcelWindow()">Cancel</button>

                <button kendoButton type="button" (click)="saveExcelSample(spreadsheet)" >Validate</button>
            </div>
            <div class="k-dialog-content">
                <ng-container kendoDialogContainer></ng-container>
            </div>
    </kendo-window>

</div> -->